import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section is-large my-3" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { "data-testid": "result-title-text" }
const _hoisted_4 = { class: "row mt-3 quick-overview" }
const _hoisted_5 = { class: "col-xs-12 col-md-3 text-right" }
const _hoisted_6 = { class: "product-badge hidden-md mb-2" }
const _hoisted_7 = { class: "inner-badge" }
const _hoisted_8 = { class: "percent" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "bigtext" }
const _hoisted_11 = { class: "smalltext" }
const _hoisted_12 = { class: "col-xs-12 col-md-9" }
const _hoisted_13 = { class: "table" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "text-primary" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_20 = { class: "text-end bg-primary text-white" }
const _hoisted_21 = { class: "text-primary" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_23 = { class: "text-end bg-primary text-white" }
const _hoisted_24 = { class: "text-end" }
const _hoisted_25 = { class: "text-end savings-padding" }
const _hoisted_26 = { class: "col-xs-12" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "pull-right" }, null, -1 /* HOISTED */)
const _hoisted_28 = { class: "responsive-table" }
const _hoisted_29 = { class: "table" }
const _hoisted_30 = { class: "text-end" }
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = { class: "text-end" }
const _hoisted_33 = { class: "field text-end" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_35 = { class: "field text-end" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_37 = { class: "field text-end" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_39 = { class: "field text-end" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_41 = { class: "field text-end" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_43 = { class: "field text-end" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_45 = { class: "field text-end" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_47 = { class: "field text-end" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_49 = { class: "field text-end" }
const _hoisted_50 = { class: "break" }
const _hoisted_51 = { class: "text-end" }
const _hoisted_52 = { class: "field text-end" }
const _hoisted_53 = { class: "text-end" }
const _hoisted_54 = { class: "field text-end" }
const _hoisted_55 = { class: "text-end" }
const _hoisted_56 = { class: "field text-end" }
const _hoisted_57 = { class: "break" }
const _hoisted_58 = { class: "text-end" }
const _hoisted_59 = { class: "field text-end" }
const _hoisted_60 = { class: "break" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_62 = { class: "field text-end" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "pull-right" }, null, -1 /* HOISTED */)
const _hoisted_64 = { class: "responsive-table" }
const _hoisted_65 = { class: "table compare-purchase" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1 /* HOISTED */)
const _hoisted_67 = { class: "field text-end" }
const _hoisted_68 = { class: "text-end" }
const _hoisted_69 = { class: "field text-end" }
const _hoisted_70 = { class: "text-end" }
const _hoisted_71 = { class: "field text-end" }
const _hoisted_72 = { class: "break" }
const _hoisted_73 = { class: "text-end" }
const _hoisted_74 = { class: "field text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("message.resultTableHeadline")), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_ctx.formatToPercent(_ctx.resultData.savings.percentageSavings)), 1 /* TEXT */)
              ]),
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("message.productBadgeBigText")), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("message.productBadgeSmallText")), 1 /* TEXT */)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("table", _hoisted_13, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("message.quickOverviewTd1")), 1 /* TEXT */),
              _hoisted_14,
              _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.formatToEuro(Math.abs(_ctx.resultData.monthlyCosts.employeeCosts.monthlyLeasingRate))), 1 /* TEXT */)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("message.quickOverviewTd2")), 1 /* TEXT */),
              _hoisted_16,
              _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.monthlySalaryConversionWithInsurance)), 1 /* TEXT */)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("strong", _hoisted_18, _toDisplayString(_ctx.$t("message.quickOverviewTd3")), 1 /* TEXT */)
              ]),
              _hoisted_19,
              _createElementVNode("td", _hoisted_20, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.monthlySalaryConversion)), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("strong", _hoisted_21, _toDisplayString(_ctx.$t("message.quickOverviewTd4")), 1 /* TEXT */)
              ]),
              _hoisted_22,
              _createElementVNode("td", _hoisted_23, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.netCharge)), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("message.quickOverviewTd5")), 1 /* TEXT */)
              ]),
              _createElementVNode("td", _hoisted_24, [
                _createElementVNode("strong", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.formatToPercent(_ctx.resultData.savings.percentageSavings)), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("td", _hoisted_25, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.savings.totalSavings)), 1 /* TEXT */)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("strong", {
            class: _normalizeClass(["accordion-head collapsed d-flex", { active: _ctx.leasingTableActive }]),
            role: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leasingTableActive = !_ctx.leasingTableActive))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("message.table1AccordionHeader")), 1 /* TEXT */),
            _hoisted_27
          ], 2 /* CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass(["accordion-body", { active: _ctx.leasingTableActive }])
          }, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("table", _hoisted_29, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("message.tableHead1")), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.$t("message.tableHead2")), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.$t("message.tableHead3")), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.monthlyIncome')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.formatToEuro(_ctx.formData.monthlyIncome)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.formatToEuro(_ctx.formData.monthlyIncome)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedCostEmployeeLeasingAt')), 1 /* TEXT */),
                  _hoisted_34,
                  _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.monthlyRates, true)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedCostEmployeeInsurancePremium')), 1 /* TEXT */),
                  _hoisted_36,
                  _createElementVNode("td", _hoisted_37, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employeeCosts.insuranceComfort)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedCostEmployeeInsurancePremiumPlus')), 1 /* TEXT */),
                  _hoisted_38,
                  _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employeeCosts.insuranceWearAndTear)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedCostEmployeeInsuranceInspection')), 1 /* TEXT */),
                  _hoisted_40,
                  _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employeeCosts.inspection)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedCostEmployerLeasing')), 1 /* TEXT */),
                  _hoisted_42,
                  _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employerCosts.leasingRate)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedCostEmployerInsurancePremium')), 1 /* TEXT */),
                  _hoisted_44,
                  _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employerCosts.insuranceComfort)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedCostEmployerInsurancePremiumPlus')), 1 /* TEXT */),
                  _hoisted_46,
                  _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employerCosts.insuranceWearAndTear)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedCostEmployerInsuranceInspection')), 1 /* TEXT */),
                  _hoisted_48,
                  _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.monthlyCosts.employerCosts.inspection)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", _hoisted_50, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedGrossIncomeAfterCalculation')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithoutLeasing.netIncome)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.netIncome)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.sozialversicherungKonstant')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithoutLeasing.socialInsuranceContribution)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.socialInsuranceContribution)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedLohnsteuer')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithoutLeasing.incomeTax)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.incomeTax)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", _hoisted_57, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.comparisonNetIncome')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithoutLeasing.payoutAmount)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.payoutAmount)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", _hoisted_60, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedNettoBelastung')), 1 /* TEXT */),
                  _hoisted_61,
                  _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.taxCalculationWithLeasing.netCharge)), 1 /* TEXT */)
                ])
              ])
            ])
          ], 2 /* CLASS */),
          _createElementVNode("strong", {
            class: _normalizeClass(["accordion-head collapsed d-flex", { active: _ctx.comparePurchaseTableActive }]),
            role: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.comparePurchaseTableActive = !_ctx.comparePurchaseTableActive))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("message.table2AccordionHeader")), 1 /* TEXT */),
            _hoisted_63
          ], 2 /* CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass(["accordion-body", { active: _ctx.comparePurchaseTableActive }])
          }, [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("table", _hoisted_65, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.totalsTotalLeasingRates')) + " ", 1 /* TEXT */),
                    _createElementVNode("span", null, _toDisplayString(_ctx.formValues.leasingTime) + " " + _toDisplayString(_ctx.$t('message.month')), 1 /* TEXT */)
                  ]),
                  _hoisted_66,
                  _createElementVNode("td", _hoisted_67, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.totalCosts.totalLeasingRates)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.calculatedRemainingBikeValue')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_68, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.bikeCosts.bikePrice)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_69, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.bikeCosts.remainingBikeValue)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.totalsTotalCostOfLeasing')) + " ", 1 /* TEXT */),
                    _createElementVNode("span", null, _toDisplayString(_ctx.formValues.leasingTime) + " " + _toDisplayString(_ctx.$t('message.month')), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.totalCosts.totalCostOfPurchase)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_71, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.totalCosts.totalCostOfLeasing)), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", _hoisted_72, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t('message.savingsAbsolute')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_73, _toDisplayString(_ctx.formatToPercent(_ctx.resultData.savings.percentageSavings)), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_74, _toDisplayString(_ctx.formatToEuro(_ctx.resultData.savings.totalSavings)), 1 /* TEXT */)
                ])
              ])
            ])
          ], 2 /* CLASS */)
        ])
      ])
    ])
  ]))
}